import * as React from "react";
import { useFramesEcommContext } from "../../../../../../../context/modules/EcommContent/FramesEcommContent/context/FramesEcommContext.js";
import { OfferingsListContainer } from "../../../../../../../../components/OfferingsList/modules/EcommContent/components/OfferingsList/OfferingsListContainer.js";
const FramesOfferingsList = () => {
  const { offerings, selectedOffering, setSelectedOffering } = useFramesEcommContext();
  if (!selectedOffering) return null;
  return /* @__PURE__ */ React.createElement(
    OfferingsListContainer,
    {
      offerings,
      selectedValue: selectedOffering,
      onChange: setSelectedOffering
    }
  );
};
export {
  FramesOfferingsList
};
//# sourceMappingURL=FramesOfferingsList.js.map
